module.exports = __webpack_public_path__ + "img/contact-linusbylund.9b35c67e.png";